import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchpaymentdata, insertCommas, formatToIndianRupees } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import './Pay_EMI.css'
import Cookies from 'js-cookie';
import PaymentFailure from '../Payment Failure/PaymentFailure';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
const apiurl = process.env.REACT_APP_API_URL;



const override = {
  display: "block",
  margin: "10% auto",
  marginLeft: '50%'
};


const Fullpayment = ({ paymentdataresponse }) => {
  const [ispaymentbuttonpressed, setIspaymentbuttonpressed] = useState(false);
  const theme = useTheme()
  const [csrfToken, setCsrfToken] = useState('');


  const totalAmount = Object.values(paymentdataresponse).reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);


  // Fetch CSRF token from the backend
  useEffect(() => {
    axios.get(`${apiurl}/get-csrf-token`, { withCredentials: true })
      .then(response => {
        setCsrfToken(response.data.csrfToken);
      })
      .catch(error => {
        console.error('Error fetching CSRF token:', error);
      });
  }, []);


  // api response is: {"Visit_Charges":0,"Overdue_EMI":0,"Overdue_Charges":0,"Late_Payment_Fee":0,"EMI_Due_For_the_Month":2900,"Charges_Due_For_the_Month":0,"Cash_Handling_Charges":0}
  let arr = [0, 0, 0, 0, 0, 0, 0];
  let arr1 = ['EMI_Due_For_the_Month', 'Charges_Due_For_the_Month', 'Overdue_EMI', 'Overdue_Charges', 'Late_Payment_Fee', 'Visit_Charges', 'Cash_Handling_Charges'];
  let remaining = totalAmount;
  let i = 0;

  if (paymentdataresponse != null) {
    while (remaining >= 0 && i < arr1.length) {
      if (remaining > paymentdataresponse[arr1[i]]) {
        remaining -= paymentdataresponse[arr1[i]];
        arr[i] = paymentdataresponse[arr1[i]];
        i++;
      } else {
        arr[i] = remaining;
        break;
      }
    }
  }

  const duesForMonth = arr[0] + arr[1];
  const arrears = arr[2] + arr[3] + arr[4] + arr[5] + arr[6];

  const paymentDetails = [
    {
      category: "Dues for the month",
      due: formatToIndianRupees(duesForMonth),
      paid: formatToIndianRupees(duesForMonth)

    },
    {
      category: "EMI Due for the Month",
      due: insertCommas(paymentdataresponse.EMI_Due_For_the_Month),
      paid: insertCommas(paymentdataresponse.EMI_Due_For_the_Month)
    },
    {
      category: "Bouncing Charge",
      due: insertCommas(paymentdataresponse.Charges_Due_For_the_Month),
      paid: insertCommas(paymentdataresponse.Charges_Due_For_the_Month)
    },
    {
      category: "Arrears",
      due: formatToIndianRupees(arrears),
      paid: formatToIndianRupees(arrears)
    },
    {
      category: "Arrears EMI",
      due: insertCommas(paymentdataresponse.Overdue_EMI),
      paid: insertCommas(paymentdataresponse.Overdue_EMI)
    },
    {
      category: "Arrear Bounce Charges",
      due: insertCommas(paymentdataresponse.Overdue_Charges),
      paid: insertCommas(paymentdataresponse.Overdue_Charges)
    },
    {
      category: "Late Payment Interest",
      due: insertCommas(paymentdataresponse.Late_Payment_Fee),
      paid: insertCommas(paymentdataresponse.Late_Payment_Fee)
    },
    {
      category: "Visit Charges",
      due: insertCommas(paymentdataresponse.Visit_Charges),
      paid: insertCommas(paymentdataresponse.Visit_Charges)
    },
    {
      category: "Cash Handling Charges",
      due: insertCommas(paymentdataresponse.Cash_Handling_Charges),
      paid: insertCommas(paymentdataresponse.Cash_Handling_Charges)
    },
    {
      category: "Grand Total",
      due: formatToIndianRupees(totalAmount),
      paid: formatToIndianRupees(totalAmount)
    }
  ];


  const handlePaymentSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());
    if (data.amount <= 0) {
      toast.error("Amount must be greater than 0")
    } else {
      setIspaymentbuttonpressed(true)
      axios.post(`${apiurl}/submit_payment`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(response => {
        window.location.href = response.data.redirecturl;
      }).catch(error => {
        setIspaymentbuttonpressed(false);
        toast.error("Payment failed. Please try again later!");
        console.log('payment error:', error)
      });
    }
  }



  return (
    <div style={{ width: '100%' }} id='payment-detail-box'>
      <table id="payment-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Due</th>
            <th>To be Paid</th>
          </tr>
        </thead>
        <tbody id="table-body">
          {
            paymentDetails.map((item, index) => (
              <tr key={index + 1} className={index === 0 || index === 3 || index === 9 ? 'subcontainerpayment' : ''}>
                <td>{item.category}</td>
                <td>{item.due}</td>
                <td>{item.paid}</td>
              </tr>
            ))
          }
        </tbody>
      </table>

      {

        <form onSubmit={handlePaymentSubmit}>
          <input type='hidden' name="csrfToken" value={csrfToken} />
          <input type="hidden" name="amount" value={totalAmount || 0} />
          <input type="hidden" name="udf4" value="Full EMI Payment" />
          <div style={{ margin: '3vw', textAlign: 'center' }}>
            <input
              type="submit"
              value={
                ispaymentbuttonpressed
                  ? "Please wait"
                  : `Proceed to pay ${formatToIndianRupees(totalAmount) || 0}`
              }
              className={totalAmount > 0 ? 'statementbutton' : 'notallowed'}
              style={{
                background: theme.palette.maincolor.buttoncolor,
                color: theme.palette.maincolor.light
              }}
            />

          </div>
        </form>
      }
    </div>)


}




const PartialPayment = ({ paymentdataresponse}) => {
  const [remainingamount, setRemainingamount] = useState(0);
  const [partialPaymentAmount] = useState('');
  const [ispaymentbuttonpressed, setIspaymentbuttonpressed] = useState(false);
  const [csrfToken, setCsrfToken] = useState('');


  useEffect(() => {
    axios.get(`${apiurl}/get-csrf-token`, { withCredentials: true })
      .then(response => {
        setCsrfToken(response.data.csrfToken);
      })
      .catch(error => {
        console.error('Error fetching CSRF token:', error);
      });
  }, []);

  const theme = useTheme()
  const totalAmount = Object.values(paymentdataresponse).reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
  const maxamount = totalAmount;

  let arr = [0, 0, 0, 0, 0, 0, 0];

  let arr1 = ['EMI_Due_For_the_Month', 'Charges_Due_For_the_Month', 'Overdue_EMI', 'Overdue_Charges', 'Late_Payment_Fee', 'Visit_Charges', 'Cash_Handling_Charges'];
  let remaining = remainingamount;
  let i = 0;

  while (remaining >= 0 && i < arr1.length) {
    if (remaining > paymentdataresponse[arr1[i]]) {
      remaining -= paymentdataresponse[arr1[i]];
      arr[i] = paymentdataresponse[arr1[i]];
      i++;
    } else {
      arr[i] = remaining;
      break;
    }
  }

  const actualduesForMonth = parseFloat(paymentdataresponse.EMI_Due_For_the_Month) + parseFloat(paymentdataresponse.Charges_Due_For_the_Month);
  const userEnteredDuesForMonth = arr[0] + arr[1];

  const actualDuesForArrears = parseFloat(paymentdataresponse.Overdue_EMI) + parseFloat(paymentdataresponse.Overdue_Charges) + parseFloat(paymentdataresponse.Late_Payment_Fee) + parseFloat(paymentdataresponse.Visit_Charges) + parseFloat(paymentdataresponse.Cash_Handling_Charges);
  const userEnteredActualDuesForArrears = arr[2] + arr[3] + arr[4] + arr[5] + arr[6];



  const paymentDetails = [
    {
      category: "Dues for the month",
      due: formatToIndianRupees(actualduesForMonth),
      paid: formatToIndianRupees(userEnteredDuesForMonth)
    },
    {
      category: "EMI Due for the Month",
      due: insertCommas(paymentdataresponse.EMI_Due_For_the_Month),
      paid: insertCommas(arr[0])
    },
    {
      category: "Bouncing Charge",
      due: insertCommas(paymentdataresponse.Charges_Due_For_the_Month),
      paid: insertCommas(arr[1])
    },
    {
      category: "Arrears",
      due: formatToIndianRupees(actualDuesForArrears),
      paid: formatToIndianRupees(userEnteredActualDuesForArrears)
    },
    {
      category: "Arrears EMI",
      due: insertCommas(paymentdataresponse.Overdue_EMI),
      paid: insertCommas(arr[2])
    },
    {
      category: "Arrear Bounce Charge",
      due: insertCommas(paymentdataresponse.Overdue_Charges),
      paid: insertCommas(arr[3])
    },
    {
      category: "Late Payment Interest",
      due: insertCommas(paymentdataresponse.Late_Payment_Fee),
      paid: insertCommas(arr[4])
    },
    {
      category: "Visit Charges",
      due: insertCommas(paymentdataresponse.Visit_Charges),
      paid: insertCommas(arr[5])
    },
    {
      category: "Cash Handling Charges",
      due: insertCommas(paymentdataresponse.Cash_Handling_Charges),
      paid: insertCommas(arr[6])
    },
    {
      category: "Grand Total",
      due: formatToIndianRupees(totalAmount),
      paid: formatToIndianRupees(remainingamount) || 0
    }
  ];




  const amount_control_message = (e) => {
    let amountentered = e.target.value;
    if (amountentered.length > 6) {
      return;
    }
    setRemainingamount(parseInt(amountentered));
  }



  const handlePaymentSubmitforpartial = (event) => {

    event.preventDefault();
    console.log(event)
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());

    let amountentered = data.amount;

    if (/[^\d\s]/.test(amountentered)) {
      toast.error('Invalid amount entered. Please enter a valid amount.');
      return;
    } else if (!/^\d+$/.test(amountentered.trim())) {
      toast.error('Invalid amount entered. Please enter a valid amount.');
      return;
    } else
      if (amountentered > maxamount) {
        toast.warn('Amount cannot be greater than max amount');
        return;
      } else
        if (data.amount <= 0) {
          toast.error("Please enter a valid amount");
          return;
        } else {
          setIspaymentbuttonpressed(true);
          axios.post(`${apiurl}/submit_payment`, data, {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            window.location.href = response.data.redirecturl;
          }).catch(error => {
            setIspaymentbuttonpressed(false);
            toast.error("Payment failed. Please try again later!");
            console.log('payment error:', error)
          });
        }
  }



  return (
    <div>
      <input
        type="input"
        value={partialPaymentAmount > 0 ? insertCommas(partialPaymentAmount) : null}
        onChange={amount_control_message}
        placeholder="Enter partial payment amount"
        id='partial-paymentinput-box'
        maxLength="8"
        pattern="[0-9]{1,6}"
        style={{ backgroundColor: theme.palette.primary[900], color: theme.palette.primary.main }}
      />
      <div style={{ width: '100%', textAlign: 'center' }} id='payment-detail-box'>
        <table id="payment-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Due</th>
              <th>To be Paid</th>
            </tr>
          </thead>
          <tbody id="table-body">
            {
              paymentDetails.map((item, index) => (
                <tr key={index + 1} className={index === 0 || index === 3 || index === 9 ? 'subcontainerpayment' : ''}>
                  <td>{item.category}</td>
                  <td>{item.due}</td>
                  <td>{item.paid}</td>
                </tr>
              ))
            }
          </tbody>
        </table>

        {
          <form onSubmit={handlePaymentSubmitforpartial}>
            <input type='hidden' name="csrfToken" value={csrfToken} />
            <input type="hidden" name="amount" value={remainingamount || 0} />
            <input type="hidden" name="udf4" value="Part EMI Payment" />
            <div style={{ margin: '3vw', textAlign: 'center' }}>


              <input
                type="submit"
                value={
                  ispaymentbuttonpressed
                    ? "Please wait"
                    : formatToIndianRupees(remainingamount) != 'Invalid amount'
                      ? `Proceed to pay ${formatToIndianRupees(remainingamount) || 0}`
                      : 'Invalid Amount'
                }
                className={remainingamount > 0 ? 'statementbutton' : 'notallowed'}
                style={{
                  background: theme.palette.maincolor.buttoncolor,
                  color: theme.palette.maincolor.light
                }}
              />
            </div>
          </form>
        }
      </div>
    </div>
  );
}





function Payment({ setEmi}) {
  const [activeButton, setActiveButton] = useState('full');
  const [showComponent, setShowComponent] = useState('full');
  const [paymentdataresponse, setPaymentdataresponse] = useState(null);
  const location = useLocation();
  const [toggle, setToggle] = useState('1');
  const [error_message, setError_message] = useState("");

  const theme = useTheme();


  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      status: params.get('status'),
      toggle: params.get('toggle'),
      error_message: params.get('failuredetail'),
    };
  };

  useEffect(() => {
    const { status, toggle, error_message } = getQueryParams();
    toggle && setToggle(toggle);
    setError_message(error_message);
    // console.log(status);
    // console.log(toggle)
  }, [location]);


  useEffect(() => {
    const paymentdata = (async () => {
      const resp = await fetchpaymentdata();
      if (resp.response.status == "200" && resp.response.message == 'Success') {
        setPaymentdataresponse(resp.response.data);
        setEmi(Object.values(resp.response.data).reduce((accumulator, currentValue) => {
          return accumulator + currentValue;
        }, 0));
      } else if (resp.response.status == "500") {
        toast.error('something went wrong. Please try again later!')
      } else if (resp.response.status == '503') {
        toast.warn(resp.response.message);
      } else if (resp.response.status == '419') {
        window.location.href = "/Session-Expired"
      } else if (resp.response.status == '401') {
        window.location.href = '/'
      }
    })
    paymentdata();
  }, [])

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType);
    setShowComponent(buttonType);
  };

  if (paymentdataresponse == null) {
    return <ClipLoader
      color="rgb(155,57,19)"
      loading={true}
      cssOverride={override}
      size={30}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  }


  return (
    <div>
      <div id="selectpaymentbutton">
        <button
          className={`paymentbutton ${activeButton === 'full' ? 'activebutton' : ''}`}
          onClick={() => handleButtonClick('full')}
          style={{
            backgroundColor: theme.palette.primary[800],
            color: activeButton === 'full' ? 'white' : theme.palette.primary.main,
          }}
        >
          Full Payment
        </button>
        <button
          className={`paymentbutton ${activeButton === 'partial' ? 'activebutton' : ''}`}
          onClick={() => handleButtonClick('partial')}
          style={{
            backgroundColor: theme.palette.primary[700],
            color: activeButton === 'partial' ? 'white' : theme.palette.primary.main,
          }}
        >
          Partial Payment
        </button>
      </div>


      {showComponent === 'full' && <Fullpayment paymentdataresponse={paymentdataresponse}/>}
      {showComponent === 'partial' && <PartialPayment paymentdataresponse={paymentdataresponse}/>}

      {toggle == '2' && <PaymentFailure error_message={error_message} toredirect="2" />}

    </div>
  );
}





const Pay_EMI = ({ setEmi, LoanAccountNumber, oppertunityId }) => {

  return (
    <>
      <ToastContainer />
      <br />
      <div style={{ display: 'flex' }}>

        <div id='fullpayment' >

          <div className='chart2'>

          </div>

          <Payment setEmi={setEmi} LoanAccountNumber={LoanAccountNumber} oppertunityId={oppertunityId} />

        </div>
      </div>
    </>
  );
};

// Define prop types
PartialPayment.propTypes = {
  paymentdataresponse: PropTypes.object.isRequired, // Array of objects
  LoanAccountNumber: PropTypes.string, // Required string
};
Fullpayment.propTypes = {
  paymentdataresponse: PropTypes.object.isRequired, // Array of objects
  LoanAccountNumber: PropTypes.string, // Required string
};
Pay_EMI.propTypes = {
  setEmi: PropTypes.func,
  LoanAccountNumber: PropTypes.string
};

Payment.propTypes = {
  setEmi: PropTypes.func.isRequired, // Required function
  LoanAccountNumber: PropTypes.string.isRequired, // Required string
};
export default Pay_EMI;

